import { foodsActions as actions } from '@/entities/foods';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { Select } from '@/shared/ui/Select/Select';

export const SelectMeasure = () => {
  const dispatch = useAppDispatch();
  const { measure } = useAppSelector((state) => state.foods.form.main);

  const { measures } = useAppSelector((state) => state.foods);
  const selected =
    measures.find((item) => String(item.id) === String(measure?.id)) ??
    measure;
  return (
    <Select
      name={'measure'}
      data-testid={'select-measure'}
      id={'measure'}
      selected={selected}
      required
      values={measures}
      handleSelect={(value) =>
        dispatch(
          actions.changeRecipesForm({
            key: 'measure',
            value: value,
          })
        )
      }
      label={'Мера'}
      placeholderClassName={selected?.title ? '' : 'text-gray-300'}
      containerClassName='w-[428px]'
      placeholder={selected?.title || 'Выберите'}
    />
  );
};
